
import { defineComponent } from '@nuxtjs/composition-api';

import WarRoomBanner from '@/components/partials/war-room/WarRoomBanner/WarRoomBanner.vue';
import HeaderAnonymousProfile from '@/components/global/HeaderMenu/HeaderAnonymousProfile/HeaderAnonymousProfile.vue';
import HeaderCommissionBalance from '@/components/global/Header/HeaderCommissionBalance/HeaderCommissionBalance.vue';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import CurrentUserQuery from '@/components/partials/war-room/WarRoomProfileBanner/apollo/currentUser.query';
import type { CurrentUser } from '@/types/graphql';

export default defineComponent({
  name: 'WarRoomProfileBanner',
  components: {
    WarRoomBanner,
    HeaderAnonymousProfile,
    HeaderCommissionBalance,
    BravadoText,
  },
  apollo: {
    currentUser: {
      query: CurrentUserQuery,
      skip() {
        return !this.$auth.loggedIn;
      },
    },
  },
  data(): { currentUser: CurrentUser | null } {
    return {
      currentUser: null,
    };
  },
  computed: {
    hasWarRoomProfile(): boolean {
      return !!this.currentUser?.username;
    },
  },
  mounted() {
    this.$apollo.queries.currentUser?.refetch();
  },
});
